export default __webpack_public_path__ + "static/media/filter_icon_pool.a9224ba6.svg";